module.exports = __webpack_public_path__ + "static/media/support-bg.3f1c010d.jpg";